<template>
  <div>
    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="16" :md="16">
            <el-form-item label="Rota" prop="rota_id" :rules="[$requiredChange]" key="rota_id">
              <el-select v-model="dados.rota_id" placeholder="pesquisar..." filterable remote :remote-method="getRotaByFilter" :loading="loadingRota">
                <el-option v-for="r in rotas" :key="r.id" :label="r.nome" :value="r.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Ordem" prop="ordem" key="ordem">
              <el-input v-model="dados.ordem" maxlength="5"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Nome" prop="nome" key="nome">
              <el-input v-model="dados.nome" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Endereço" prop="endereco" key="endereco">
              <el-input v-model="dados.endereco" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Latitude" prop="latitude" key="latitude">
              <el-input v-model="dados.latitude" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Longitude" prop="longitude" key="longitude">
              <el-input v-model="dados.longitude" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" class="u-text-right">
            <el-button type="info" plain icon="el-icon-location" @click="centerOnMarker" class="u-mt-25">CENTRALIZAR</el-button>
          </el-col>
        </el-row>

        <div class="u-mt-10">
          <div id="map-ponto" :style="`width: 100%; height: 360px; border: 1px solid #e6e6e6; border-radius: 6px;`"></div>
          <div class="u-mt-5" style="color:#666; font-size: 12px;">
            Clique no mapa para preencher latitude/longitude.
          </div>
        </div>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-ponto" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    edit: false,
    loadingRota: false,
    rotas: [],
    map: null,
    marker: null,
    dados: {
      id: '',
      rota_id: '',
      nome: '',
      endereco: '',
      latitude: '',
      longitude: '',
      ordem: 0
    }
  }),
  mounted () {
    // No modo edição o form (e o div do mapa) só aparece depois do getById.
    // Então precisamos aguardar o DOM existir para não passar null ao Google Maps.
    this.$nextTick(() => this.initMapSafe())
  },
  methods: {
    async initMapSafe () {
      if (this.map) return
      const el = document.getElementById('map-ponto')
      if (!el) return

      await this.$gmapApiPromiseLazy()
      const center = new google.maps.LatLng(-14.849752, -40.846006)
      this.map = new google.maps.Map(el, { zoom: 14, center, mapTypeId: 'roadmap' })
      this.map.addListener('click', (e) => {
        const lat = e.latLng.lat()
        const lng = e.latLng.lng()
        this.dados.latitude = lat
        this.dados.longitude = lng
        this.setMarker(lat, lng)
      })

      // se já veio com coordenadas (edit), posiciona marker
      if (this.dados.latitude && this.dados.longitude) {
        this.setMarker(this.dados.latitude, this.dados.longitude)
      }
    },
    setMarker (lat, lng) {
      if (!this.map) return
      const pos = new google.maps.LatLng(parseFloat(lat), parseFloat(lng))
      if (!this.marker) {
        this.marker = new google.maps.Marker({ position: pos, map: this.map })
      } else {
        this.marker.setPosition(pos)
      }
      this.map.setCenter(pos)
    },
    centerOnMarker () {
      if (!this.marker || !this.map) return
      this.map.setCenter(this.marker.getPosition())
    },
    getRotaByFilter (query) {
      if (!query || query.length < 2) { this.rotas = []; return }
      this.loadingRota = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.rotas = JSON.parse(JSON.stringify(res.data)); this.loadingRota = false })
        .catch(e => { this.loadingRota = false; this.$store.commit('throwException', e) })
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/ponto/getById/` + id, this.$store.getters.getHeaderAuth)
      const data = JSON.parse(JSON.stringify(res.data))
      if (data && data.rota) {
        this.rotas = [{ id: data.rota.id, nome: data.rota.nome }]
        delete data.rota
      }
      this.dados = data
      // aguarda render do form no edit e inicializa o mapa com marker
      this.$nextTick(() => this.initMapSafe())
    },
    onSubmit () {
      document.getElementById("btn-ponto").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        try {
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/ponto/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
          } else {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/ponto/store`, this.dados, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitPonto')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        } else {
          // create: garantir mapa inicializado
          this.edit = false
          this.$nextTick(() => this.initMapSafe())
        }
      }
    }
  }
}
</script>

